export function randomiseChoices(choices: any[], randomise: boolean) {
  if (!randomise) {
    return choices;
  }

  const randomisedChoices = [...choices];

  for (let i = randomisedChoices.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));

    const temp = randomisedChoices[i];
    randomisedChoices[i] = randomisedChoices[randomIndex];
    randomisedChoices[randomIndex] = temp;
  }

  return randomisedChoices;
}

export function removeMarkdown(text: string) {
  return text
    .replace(/(\*\*|__)(.*?)\1/g, '$2') // Bold
    .replace(/(\*|_)(.*?)\1/g, '$2') // Italics
    .replace(/~~(.*?)~~/g, '$1') // Strikethrough
    .replace(/#+\s(.*?)/g, '$1') // Headings
    .replace(/\[.*?\]\((.*?)\)/g, '$1') // Links
    .replace(/`([^`]+)`/g, '$1'); // Inline code
}
